import { combineReducers } from 'redux'

import { DATE_VALUES } from 'utils/dateUtils'

import editTenantReducer from './EditTenant/reducer'
import {
  COMPANIES_FILTER_CHANGE,
  COMPANIES_PAGE_CHANGE,
  COMPANY_FILTER_OPTIONS,
  FETCH_POSSIBLE_ACQUIRING_PARTNERS_ASYNC,
  INCIDENTS_FILTER_CHANGE,
  MIGRATE_COMPANY_ASYNC,
  NEW_COMPANY_ADD_ASYNC,
  NEW_COMPANY_RESET_MESSAGE,
  PARTNER_COMPANIES_GET_ASYNC,
  PARTNER_INCIDENTS_GET_ASYNC,
  PARTNER_STATISTICS_GET_ASYNC,
  PARTNER_SUCCESS_SUBMISSION_SEND_ASYNC,
  SEARCH_CHANGE,
  SEARCH_RESET,
  SORT_PROPERTY_CHANGE,
} from './constants'
import { getKeyForMigratingCompany } from './utils'

const initialState = {
  data: {
    companies: [],
    totalPages: 0,

    incidents: {},
    statistics: {},
  },

  loader: false,
  incidentsLoader: false,
  statisticsLoader: false,

  timeFilter: DATE_VALUES.LAST_24_HOURS,

  page: 1,
  search: '',
  sortProperty: 'id-asc',
  companiesFilter: COMPANY_FILTER_OPTIONS.ALL_COMPANIES,

  addCompanyLoader: false,
  addCompanyMessage: '',
  partnerSuccessSubmissionLoader: false,
  partnerSuccessSubmissionError: '',
  possibleAcquiringPartners: {},
  fetching: {},
}

function partnerDashboardReducer() {
  return (state = initialState, action) => {
    switch (action.type) {
      case PARTNER_COMPANIES_GET_ASYNC.INITIATE:
        return {
          ...state,
          loader: true,
        }
      case PARTNER_COMPANIES_GET_ASYNC.SUCCESS:
        return {
          ...state,
          loader: false,
          data: {
            ...state.data,
            ...action.payload.data,
          },
        }
      case PARTNER_COMPANIES_GET_ASYNC.ERROR:
      case PARTNER_COMPANIES_GET_ASYNC.CANCEL:
        return {
          ...state,
          loader: false,
        }
      case NEW_COMPANY_ADD_ASYNC.INITIATE:
        return {
          ...state,
          page: 1,
          addCompanyLoader: true,
          addCompanyMessage: '',
        }
      case NEW_COMPANY_RESET_MESSAGE:
        return {
          ...state,
          addCompanyLoader: false,
          addCompanyMessage: '',
        }
      case NEW_COMPANY_ADD_ASYNC.SUCCESS:
        return {
          ...state,
          loader: true,
          addCompanyLoader: false,
          addCompanyMessage: '',
        }
      case NEW_COMPANY_ADD_ASYNC.ERROR:
        return {
          ...state,
          addCompanyLoader: false,
          addCompanyMessage: action.error.detail,
        }
      case SEARCH_RESET:
        return {
          ...state,
          search: '',
        }
      case SEARCH_CHANGE:
        return {
          ...state,
          loader: true,
          page: 1,
          search: action.payload.q,
        }
      case COMPANIES_PAGE_CHANGE:
        return {
          ...state,
          loader: true,
          page: action.payload.page,
        }
      case SORT_PROPERTY_CHANGE:
        return {
          ...state,
          loader: true,
          sortProperty: action.payload.value,
        }
      case COMPANIES_FILTER_CHANGE:
        return {
          ...state,
          loader: true,
          page: 1,
          companiesFilter: action.payload.filter,
        }
      case INCIDENTS_FILTER_CHANGE:
        return {
          ...state,
          incidentsLoader: true,
          timeFilter: action.payload.filter,
        }
      case PARTNER_INCIDENTS_GET_ASYNC.INITIATE:
        return {
          ...state,
          incidentsLoader: true,
        }
      case PARTNER_INCIDENTS_GET_ASYNC.SUCCESS:
        return {
          ...state,
          incidentsLoader: false,
          data: {
            ...state.data,
            // incidents must stay an object (render reads .new/.phishing/... off
            // it); guard against a missing/empty payload so the MSP dashboard
            // degrades to "no incidents" instead of crashing on `.new`.
            incidents: action.payload.data.incidents || {},
          },
        }
      case PARTNER_INCIDENTS_GET_ASYNC.CANCEL:
      case PARTNER_INCIDENTS_GET_ASYNC.ERROR:
        return {
          ...state,
          incidentsLoader: false,
        }
      case PARTNER_STATISTICS_GET_ASYNC.INITIATE:
        return {
          ...state,
          statisticsLoader: true,
        }
      case PARTNER_STATISTICS_GET_ASYNC.SUCCESS:
        return {
          ...state,
          statisticsLoader: false,
          data: {
            ...state.data,
            statistics: action.payload.data,
          },
        }
      case PARTNER_STATISTICS_GET_ASYNC.CANCEL:
      case PARTNER_STATISTICS_GET_ASYNC.ERROR:
        return {
          ...state,
          statisticsLoader: false,
        }
      case PARTNER_SUCCESS_SUBMISSION_SEND_ASYNC.INITIATE:
        return {
          ...state,
          partnerSuccessSubmissionLoader: true,
          partnerSuccessSubmissionError: '',
        }
      case PARTNER_SUCCESS_SUBMISSION_SEND_ASYNC.SUCCESS:
      case PARTNER_SUCCESS_SUBMISSION_SEND_ASYNC.CANCEL:
        return {
          ...state,
          partnerSuccessSubmissionLoader: false,
          partnerSuccessSubmissionError: '',
        }
      case PARTNER_SUCCESS_SUBMISSION_SEND_ASYNC.ERROR:
        return {
          ...state,
          partnerSuccessSubmissionLoader: false,
          partnerSuccessSubmissionError:
            action.error?.detail || action.error?.message || 'Could not send request',
        }
      case FETCH_POSSIBLE_ACQUIRING_PARTNERS_ASYNC.INITIATE: {
        return {
          ...state,
          possibleAcquiringPartners: {
            data: [],
            loader: true,
          },
        }
      }
      case FETCH_POSSIBLE_ACQUIRING_PARTNERS_ASYNC.SUCCESS: {
        return {
          ...state,
          possibleAcquiringPartners: {
            data: action.payload,
            loader: false,
          },
        }
      }
      case MIGRATE_COMPANY_ASYNC.ERROR:
      case MIGRATE_COMPANY_ASYNC.CANCEL:
      case MIGRATE_COMPANY_ASYNC.SUCCESS: {
        return {
          ...state,
          fetching: {
            [getKeyForMigratingCompany(action.payload?.companyId) || action.error]: false,
          },
        }
      }
      case MIGRATE_COMPANY_ASYNC.INITIATE: {
        return {
          ...state,
          fetching: {
            [getKeyForMigratingCompany(action.payload.companyId)]: true,
          },
        }
      }
      default:
        return state
    }
  }
}

export default function () {
  const initialState = combineReducers({
    self: partnerDashboardReducer(),
    editTenant: editTenantReducer(),
  })

  return (state = initialState, action) => {
    switch (action.type) {
      default:
        return state
    }
  }
}
